// Copyright (C) 2019 TANNER AG

import {
	SET_PURCHASE_PRICE,
	SET_RESIDUAL_VALUE,
	SET_ANNUAL_MILEAGE,
	SET_DRIVING_PROFILE,
	SET_EFFICIENT_HYBRID,
	SET_FUEL_PRICE,
	SET_HOLDING_PERIOD,
	ADD_BUS,
	SET_CONFIGURATION,
	RESET
} from "./actions";

const emptyBus = () => ({
	id: null,
	name: null,
	doors: null,
	fuel: null,
	type: null,
	efficientHybrid: false
});

const getInitialConfigState = () => ({
	bus: emptyBus(),
	purchasePrice: null,
	residualValue: null,
	drivingProfile: null,
	efficientHybrid: null,
	fuelPrice: null,
	holdingPeriod: null,
	annualMileage: null
});

const initialState = {
	a: getInitialConfigState(),
	b: getInitialConfigState(),
	configuration: null
};

export const tco = (state = {}, action) => {
	const { a, b, ...others } = Object.assign(initialState, state);

	switch (action.type) {
		case RESET:
			return {
				a: getInitialConfigState(),
				b: getInitialConfigState(),
				configuration: null
			};

		case ADD_BUS:
			if (action.char === "A") {
				if (a.bus.id === action.bus.id) {
					a.bus = emptyBus();
				} else {
					a.bus = action.bus;
				}
			}

			if (action.char === "B") {
				if (b.bus.id === action.bus.id) {
					b.bus = emptyBus();
				} else {
					b.bus = action.bus;
				}
			}

			return { a, b };

		case SET_CONFIGURATION:
			return { a, b, configuration: action.value };

		case SET_PURCHASE_PRICE:
			return {
				a: { ...a, purchasePrice: action.valueA },
				b: { ...b, purchasePrice: action.valueB },
				...others
			};

		case SET_RESIDUAL_VALUE:
			return {
				a: { ...a, residualValue: action.valueA },
				b: { ...b, residualValue: action.valueB },
				...others
			};

		case SET_DRIVING_PROFILE:
			return {
				a: { ...a, drivingProfile: action.value },
				b: { ...b, drivingProfile: action.value },
				...others
			};

		case SET_EFFICIENT_HYBRID:
			return {
				a: { ...a, efficientHybrid: action.valueA },
				b: { ...b, efficientHybrid: action.valueB },
				...others
			};

		case SET_HOLDING_PERIOD:
			return {
				a: { ...a, holdingPeriod: action.value },
				b: { ...b, holdingPeriod: action.value },
				...others
			};

		case SET_ANNUAL_MILEAGE:
			return {
				a: { ...a, annualMileage: action.value },
				b: { ...b, annualMileage: action.value },
				...others
			};

		case SET_FUEL_PRICE:
			return {
				a: { ...a, fuelPrice: action.valueA },
				b: { ...b, fuelPrice: action.valueB },
				...others
			};

		default:
			return { a, b, ...others };
	}
};



// WEBPACK FOOTER //
// ./src/tco/store/reducer.js